module.exports = __webpack_public_path__ + "static/konto-bw-d409e1e55a2a4d98bed246b7fb21386f.jpg";